module.exports = __webpack_public_path__ + "img/success_img.aaf6a972.svg";